import React from 'react';

interface CheckboxProps {
  label?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  required?: boolean;
  disabled?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({ label, checked, onChange, required, disabled }) => {
  return (
    <label className="flex items-center gap-2 cursor-pointer">
      <input
        type="checkbox"
        checked={checked || false}
        onChange={e => onChange?.(e.target.checked)}
        required={required}
        disabled={disabled}
        className="w-4 h-4 rounded border-slate-300 text-primary-600 focus:ring-primary-500"
      />
      {label && <span className="text-sm text-slate-700">{label}</span>}
    </label>
  );
};
